import { z } from 'zod';

const decimalString = z.string().regex(/^-?\d+(\.\d+)?$/, 'invalidDecimal');

export const FixingSchema = z.object({
  index_name: z.string().trim().min(1, 'required'),
  fixing_date: z.string().min(1, 'required'),
  value: decimalString,
  currency: z.string().trim().length(3, 'currency3'),
});

export type Fixing = z.infer<typeof FixingSchema>;

export const FixingsQueryFiltersSchema = z
  .object({
    index_name: z.string().trim().optional(),
    fixing_date: z.string().optional(),
    from_date: z.string().optional(),
    to_date: z.string().optional(),
  })
  .refine(
    (v) => {
      const one = Boolean(v.from_date);
      const two = Boolean(v.to_date);
      return one === two;
    },
    {
      message: 'provideBothOrNeither',
      path: ['from_date'],
    },
  );

export type FixingsQueryFilters = z.infer<typeof FixingsQueryFiltersSchema>;
